module.exports = __webpack_public_path__ + "assets/35f2a5915966b42a554cc4d231073d83.png";